import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTitle, updateDescPoints } from "../redux/career/actions";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

function CreateCareerPost() {
  const dispatch = useDispatch();
  const { descPoints, title } = useSelector((state) => state.career);
  const [formerror, setFormError] = useState({});
  const [publishError, setPublishError] = useState(null);
  const [successMsg, SetSuccessMsg] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [enteredtechnologies, setEnteredTechnologies] = useState([]);

  const handleInputChange = (e) => setInputValue(e.target.value);
  const handleAddTechnology = () => {
    if (inputValue.trim() !== "") {
      const updatedTechs = [...enteredtechnologies, inputValue.trim()];
      setEnteredTechnologies(updatedTechs);
      setInputValue("");
      dispatch(updateDescPoints(updatedTechs));
    }
  };
  const handleDeleteTechnology = (index) => {
    const updatedTechList = [...enteredtechnologies];
    updatedTechList.splice(index, 1);
    setEnteredTechnologies(updatedTechList);
    dispatch(updateDescPoints(updatedTechList));
  };
  const validation = () => {
    let err = {};
    if (title === "") err.portfolio_title = "Please Enter Title.";
    if (enteredtechnologies.length === 0) err.technologies = "Please Enter at least one Description point.";
    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };
  const handleSubmit = async () => {
    let isvalid = validation();
    if (isvalid) {
      try {
        const res = await fetch(
          `${BASE_URL}/api/career/create`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              name: title,
              descPoints: enteredtechnologies,
            }),
          }
        );
        const data = await res.json();
        if (!res.ok) {
          setPublishError(data.message);
          return;
        }
        setPublishError(null);
        SetSuccessMsg(true);
      } catch (error) {
        setPublishError(error.message);
      }
    }
  };

  return (
    <div className="container">
      <h3
        className="fw-bold mb-4"
        style={{
          color: "#1e3a8a",
          letterSpacing: "-0.5px",
        }}
      >
        Create Career Post
      </h3>
      <div className="row">
        <div className="col-12 text-start">
          {/* Title Field */}
          <div className="mb-4 text-start">
            <label className="form-label fw-semibold" style={{ color: "#333" }}>
              Career Title
            </label>
            <input
              type="text"
              className="form-control shadow-sm text-start"
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
              }}
              placeholder="Enter career title"
              name="career_title"
              onChange={(e) => dispatch(updateTitle(e.target.value))}
              value={title}
            />
            <small className="text-danger">{formerror.portfolio_title}</small>
          </div>

          {/* Description Points */}
          <div className="mb-4 text-start">
            <label className="form-label fw-semibold" style={{ color: "#333" }}>
              Description Points
            </label>
            <small className="text-muted d-block mb-2">
              Add each point individually
            </small>

            <textarea
              className="form-control shadow-sm text-start"
              rows={3}
              placeholder="Type a point"
              value={inputValue}
              onChange={handleInputChange}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.75rem",
              }}
            />

            {/* Buttons */}
            <div className="d-flex gap-2 mt-3 text-start">
              <button
                className="btn btn-primary d-flex align-items-center gap-2 text-start"
                style={{ padding: "0.55rem 1.1rem", borderRadius: "6px" }}
                onClick={handleAddTechnology}
              >
                <i className="bi bi-plus-lg"></i> Add
              </button>

              <button
                className="btn btn-success text-start"
                style={{ padding: "0.55rem 1.1rem", borderRadius: "6px" }}
                onClick={() => dispatch(updateDescPoints([...enteredtechnologies]))}
              >
                Save Points
              </button>
            </div>

            <small className="text-danger">{formerror.technologies}</small>

            {/* List of points */}
            <ul
              className="list-group mt-3 shadow-sm text-start"
              style={{ borderRadius: "6px" }}
            >
              {enteredtechnologies.map((tech, index) => (
                <li
                  key={index}
                  className="list-group-item d-flex justify-content-between align-items-center text-start"
                  style={{
                    border: "1px solid #ececec",
                    fontSize: "0.95rem",
                    color: "#444",
                  }}
                >
                  <span>{tech}</span>
                  <div className="d-flex gap-2 text-start">
                    <button
                      className="btn btn-outline-danger btn-sm d-flex align-items-center text-start"
                      style={{ borderRadius: "4px" }}
                      onClick={() => handleDeleteTechnology(index)}
                    >
                      <i className="bi bi-trash"></i> Delete
                    </button>
                    <button
                      className="btn btn-outline-primary btn-sm d-flex align-items-center text-start"
                      style={{ borderRadius: "4px" }}
                      disabled
                    >
                      <i className="bi bi-pencil-square"></i> Edit
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Submit Button */}
          <button
            onClick={handleSubmit}
            className="btn btn-primary w-100 fw-semibold"
            style={{
              background: "linear-gradient(90deg, #1e3a8a, #2563eb)",
              color: "white",
              padding: "14px",
              borderRadius: "8px",
              fontSize: "17px",
              border: "none",
              boxShadow: "0 4px 14px rgba(37, 99, 235, 0.12)",
              cursor: "pointer",
              transition: "0.25s ease",
              marginTop: "16px"
            }}
          >
            Submit
          </button>

          {/* Messages */}
          {publishError && <div className="text-danger mt-2">{publishError}</div>}
          {successMsg && (
            <div className="alert alert-success mt-3">
              Post Created Successfully!
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateCareerPost;
